import styled from 'styled-components'
import { Typography, Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const Container = styled.div`
  background: ${Colors.Neutral5};
`

export const ColorsList = styled.div`
  padding: 16px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;

  ${Media.Phone`
    padding: 16px;
    overflow-x: auto;
  `}
`

export const ColorsItem = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;

  ${Media.Laptop`
    flex-direction: column;
    gap: 8px;
  `}

  ${Media.Tablet`
    flex-direction: column-reverse;
    gap: 8px;
  `}
`

export const ColorsItemText = styled.div`
  ${Typography.sizes.Caption}
  color: ${Colors.Neutral90};
  font-weight: ${Typography.weights.regular};
`

export const ColorsItemPreview = styled.div``

export const Separator = styled.div`
  width: 1px;
  height: 24px;
  background: ${Colors.Neutral20};

  ${Media.Tablet`
    height: 44px;
  `}
`
